import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ISettingsTrenchSlice {
  trench: any;
  trenchMembers: any;
}

const initialState: ISettingsTrenchSlice = {
  trench: null,
  trenchMembers: [],
};
export const SettingsTrenchSlice = createSlice({
  name: "settings_trench_slice",
  initialState,
  reducers: {
    setTrench: (state, action: PayloadAction<any>) => {
      state.trench = action.payload;
    },
    setTrenchMembers: (state, action: PayloadAction<any>) => {
      state.trenchMembers = action.payload;
    },
    changeRole: (state, action: PayloadAction<any>) => {
      const { memberId, role } = action.payload;
      const index = state.trenchMembers.findIndex(
        (member: any) => member.memberId === memberId
      );
      if (index === -1) return;
      if (state.trenchMembers.length) {
        state.trenchMembers[index].memberRole = role;
      }
    },
    removeMember: (state, action: PayloadAction<any>) => {
      const { memberId } = action.payload;
      state.trenchMembers = state.trenchMembers.filter(
        (member: any) => member.memberId !== memberId
      );
    },
    banUnBanTrenchMember: (state, action: PayloadAction<any>) => {
      const { memberId, banFlag } = action.payload;
      const index = state.trenchMembers.findIndex(
        (member: any) => member.memberId === memberId
      );
      if (index === -1) return;
      if (state.trenchMembers.length) {
        state.trenchMembers[index].banFlag = banFlag;
      }
    },
  },
});

export const {
  setTrenchMembers,
  setTrench,
  changeRole,
  removeMember,
  banUnBanTrenchMember,
} = SettingsTrenchSlice.actions;

export default SettingsTrenchSlice.reducer;
